import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {Toast} from "../toast.interface";

@Component({
  selector: 'app-toaster',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast toast-{{toast.type}}"
         [style.top.px]="i*120">
      <h4 class="toast-heading">{{toast.title}}</h4>
      <p class="toast-body">{{toast.body}}</p>
      <a class="close" (click)="remove.emit(i)">&times;</a>
    </div>
  `,
  styles:  `
    .toast {
      position: fixed;
      right: 0;
      top: 0;
      width: 300px;
      min-height: 100px;
      box-sizing: border-box;
      padding: .75rem 2.25rem .75rem 1.25rem;
      margin: 1rem 1rem 1rem 1rem;
      border: 1px solid transparent;
      border-radius: .25rem;
      animation: move 2s both;
    }

    .toast-body {
      margin: .25rem 0 0;
      overflow-wrap: anywhere;
    }

    .toast-success {
      color: #155724;
      background-color: #d4edda;
      border-color: #c3e6cb;
    }

    .toast-error {
      color: #721c24;
      background-color: #f8d7da;
      border-color: #f5c6cb;
    }

    .toast-warning {
      color: #856404;
      background-color: #fff3cd;
      border-color: #ffeeba;
    }

    .close {
      position: absolute;
      top: 7px;
      right: 10px;
      font-size: 1.5em;
      cursor: pointer;
    }

    .toast-heading {
      margin-top: 10px;
    }

    @keyframes move {
      from {
        transform: translateX(100%);
      }
      to {
        transform: translateX(0);
      }
    }
  `
})
export class ToasterComponent {
  @Input()
  toast!: Toast;
  @Input()
  i!: number;

  @Output() remove = new EventEmitter<number>();
}
